module.exports = "h4::before{\n    content: \"\\2014\";\n    font-size: inherit;\n    color:#ff000f;\n    display: block\n}"